'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$43() {
  this.b0c = null;
  this.b0a = null;
  this.b0b = false;
  this.b08 = null;
  this.b09 = false;
  this.b0d = false;
  this.b0e = false;
  this.b0c = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_GroupsView$$anon$43 as $c_Lpresto_GroupsView$$anon$43 };
$p = $c_Lpresto_GroupsView$$anon$43.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$43;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$43() {
}
export { $h_Lpresto_GroupsView$$anon$43 as $h_Lpresto_GroupsView$$anon$43 };
$h_Lpresto_GroupsView$$anon$43.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.b0c;
});
$p.t = (function() {
  if ((!this.b0b)) {
    this.b0a = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("doctype", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b0b = true;
  }
  return this.b0a;
});
$p.ad = (function() {
  if ((!this.b09)) {
    this.b08 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().adk()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b09 = true;
  }
  return this.b08;
});
$p.v = (function() {
  if ((!this.b0e)) {
    this.b0d = false;
    this.b0e = true;
  }
  return this.b0d;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_GroupsView$$anon$43 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$43, "presto.GroupsView$$anon$43", ({
  Ku: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$43 as $d_Lpresto_GroupsView$$anon$43 };
//# sourceMappingURL=presto.-Groups-View$$anon$43.js.map
